import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArrowIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Sensors-Selection-+-Pressure-Sensors-Config."
          transform="translate(-1156.000000, -412.000000)"
          fill={color ?? token.colorTextTertiary}
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(238.000000, 196.000000)">
            <g id="Group-15" transform="translate(365.000000, 46.000000)">
              <g id="up-and-down-copy" transform="translate(553.000000, 170.000000)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.21236 4.83748C2.44016 4.60967 2.80951 4.60967 3.03732 4.83748L6.99984 8.8L10.9624 4.83748C11.1902 4.60967 11.5595 4.60967 11.7873 4.83748C12.0151 5.06529 12.0151 5.43463 11.7873 5.66244L7.41232 10.0374C7.18451 10.2652 6.81516 10.2652 6.58736 10.0374L2.21236 5.66244C1.98455 5.43463 1.98455 5.06529 2.21236 4.83748Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowIcon;
